import { MutationHookOptions, MutationResult } from "@apollo/client";
import { useMutation } from "../../../hooks";
import { FetchResult } from "@apollo/client/link/core";
import { removeFromMatterAssumptionsCache } from "../../query";
import {
  deleteAssumptions,
  deleteAssumptionsVariables,
} from "../../__generated_types__/deleteAssumptions";
import { graphql } from "~/gql";

export const DELETE_ASSUMPTIONS = graphql(/* GraphQL */ `
  mutation deleteAssumptions($assumptionIds: [Int!]!) {
    deleteAssumptions(assumptionIds: $assumptionIds) {
      assumptionIds
    }
  }
`);

export type DeleteAssumptionsMutationFunction = (
  matterId: number,
  assumptionIds: number | number[],
  options?: MutationHookOptions<deleteAssumptions, deleteAssumptionsVariables>
) => Promise<FetchResult<deleteAssumptions>>;

export function useDeleteAssumptionsMutation(
  options?: MutationHookOptions<deleteAssumptions, deleteAssumptionsVariables>
): [DeleteAssumptionsMutationFunction, MutationResult<deleteAssumptions>] {
  const [mutationFunction, mutationResult] = useMutation<
    deleteAssumptions,
    deleteAssumptionsVariables
  >(DELETE_ASSUMPTIONS, {
    ...(options || {}),
    errorPolicy: "all",
  });
  const deleteAssumptionsMutation: DeleteAssumptionsMutationFunction = (
    matterId,
    assumptionIds,
    options
  ) => {
    return mutationFunction({
      variables: {
        assumptionIds: Array.isArray(assumptionIds) ? assumptionIds : [assumptionIds],
      },
      update(cache) {
        removeFromMatterAssumptionsCache(cache, matterId, assumptionIds);
      },
      ...(options || {}),
    });
  };
  return [deleteAssumptionsMutation, mutationResult];
}
